import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
    },
    listItem: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    navLink: {
        '&:hover': {
            color: theme.palette.primary.dark,
        },
    },
    listItemIcon: {
        minWidth: 'auto',
    },
    closeIcon: {
        justifyContent: 'flex-end',
        cursor: 'pointer',
    },
    menu: {
        display: 'flex',
    },
    menuItem: {
        marginRight: theme.spacing(8),
        '&:last-child': {
            marginRight: 0,
        },
    },
    menuGroupItem: {
        paddingTop: 0,
    },
    menuGroupTitle: {
        textTransform: 'uppercase',
    },
    divider: {
        width: '100%',
    },
}));

export default useStyles;